<script setup>
import { computed } from 'vue';
import SettingsHeader from '../../SettingsHeader.vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  headerTitle: { type: String, default: '' },
  headerButtonText: { type: String, default: '' },
  icon: { type: String, default: '' },
  keepAlive: { type: Boolean, default: true },
  showBackButton: { type: Boolean, default: false },
  backUrl: { type: [String, Object], default: '' },
});

const { t } = useI18n();

const showSettingsHeader = computed(
  () => props.headerTitle || props.icon || props.showBackButton
);
</script>

<template>
  <div
    class="flex flex-col w-full h-full m-0 overflow-auto bg-n-surface-1 font-inter"
  >
    <SettingsHeader
      v-if="showSettingsHeader"
      button-route="new"
      :icon="icon"
      :header-title="t(headerTitle)"
      :button-text="t(headerButtonText)"
      :show-back-button="showBackButton"
      :back-url="backUrl"
      :show-new-button="false"
      class="sticky top-0 z-20 max-w-6xl w-full mx-auto"
    />

    <div class="flex items-start w-full mx-auto">
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive">
          <component :is="Component" />
        </keep-alive>
        <component :is="Component" v-else />
      </router-view>
    </div>
  </div>
</template>
